function directSpoilerCards(container) {
  return Array.from(container.children).filter((child) => {
    return child.classList.contains("spoiler-card-unit") || child.classList.contains("spoiler-card")
  })
}

function firstRenderedRowCards(cards) {
  const firstCard = cards[0]
  if (!firstCard) return []

  const firstRect = firstCard.getBoundingClientRect()

  if (firstRect.width === 0 && firstRect.height === 0) return []

  const firstTop = firstRect.top
  return cards.filter((card) => Math.abs(card.getBoundingClientRect().top - firstTop) <= 4)
}

export function positionSealedProductsFrameAfterFirstRow(container, frame) {
  if (!container || !frame) return false

  const originalDisplay = frame.style.display
  frame.style.display = "none"

  const rowCards = firstRenderedRowCards(directSpoilerCards(container))
  frame.style.display = originalDisplay

  if (rowCards.length === 0) return false

  rowCards[rowCards.length - 1].insertAdjacentElement("afterend", frame)
  return true
}

export function positionSealedProductsFrameAfterFirstDeck(container, frame) {
  if (!container || !frame) return false

  const placeholder = Array.from(container.querySelectorAll("ins.widget-deck-placeholder[data-id]"))
    .find((candidate) => {
      const value = (candidate.dataset.id || "").trim()
      return /^[0-9]+$/.test(value) && Number(value) > 0
    })
  if (!placeholder) return false

  const parent = placeholder.parentElement
  const significantChildren = parent && parent.tagName === "P"
    ? Array.from(parent.childNodes).filter((node) => {
      return node.nodeType !== Node.COMMENT_NODE &&
        !(node.nodeType === Node.TEXT_NODE && node.textContent.trim() === "")
    })
    : []
  const insertionTarget = significantChildren.length === 1 && significantChildren[0] === placeholder
    ? parent
    : placeholder

  insertionTarget.insertAdjacentElement("afterend", frame)
  return true
}
